import {Injectable} from '@angular/core';
import {NestApiProvider} from '../../nest-api';
import {Observable} from 'rxjs';
import {ResponseData} from '../../nest-responses';
import {RequestFindByEmpNo, ResponseFindByEmpNo} from '../dto/kiosk.dto';

@Injectable()
export class KioskApi {
  private readonly service: string = '';
  private readonly model: string = 'kiosk';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public getProfileByQrcode(payload: RequestFindByEmpNo): Observable<ResponseData<ResponseFindByEmpNo>> {
    const method: string = 'POST';
    const func: string = 'getProfileByQrcode';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseFindByEmpNo>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/kiosk.api.ts